
export default {
props:['cart','setShipping'],
mounted(){
},
methods:{
    navNext(){
        if(!this.$el.querySelector('.native-slider')){
            return
        }
        this.$el.querySelector('.native-slider').scrollLeft += 400
    },
    navPrevious(){
        if(!this.$el.querySelector('.native-slider')){
            return
        }
        this.$el.querySelector('.native-slider').scrollLeft -= 400
    }
}
}
